import type { ITestSectionScoresReportState } from '@/store/modules/report/test-section-scores-report/types';

export const state: ITestSectionScoresReportState = {
  testSectionScores: null,
};
